import { render } from "./AssginDplaceListModal.vue?vue&type=template&id=5a341df5&scoped=true"
import script from "./AssginDplaceListModal.vue?vue&type=script&lang=js"
export * from "./AssginDplaceListModal.vue?vue&type=script&lang=js"

import "./AssginDplaceListModal.vue?vue&type=style&index=0&id=5a341df5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a341df5"

export default script